import b2bOpsAxios from "../lib/axios";

export const getTeamData = async (id: string) => {
  const response = await b2bOpsAxios.get(`/api/team/${id}/info/`);

  return response.data;
};

export const getTeamList = async () => {
  const response = await b2bOpsAxios.get("/api/team/team_list/");

  return response.data;
};

export const getTeamByKey = async (team_key: string) => {
  const response = await b2bOpsAxios.get(
    `/api/team/team_by_key/?team_key=${team_key}`
  );

  return response.data;
};

export const getTeamSendHistory = async (
  id: string,
  startDate?: string,
  endDate?: string
) => {
  const response = await b2bOpsAxios.get(
    `/api/team/${id}/order_list/?startDate=${startDate}&endDate=${endDate}`
  );

  return response.data;
};

export const getTeamAllSendHistory = async ({
  startDate,
  endDate,
  teamId,
  justWreath,
  justDisposal,
}: {
  startDate?: string;
  endDate?: string;
  teamId?: string;
  justWreath?: boolean;
  justDisposal?: boolean;
}) => {
  const response = await b2bOpsAxios.get(
    `/api/team/admin_order_list/?${startDate ? `startDate=${startDate}` : ""}${
      endDate ? `&endDate=${endDate}` : ""
    }${teamId ? `&teamId=${teamId}` : ""}${
      justWreath ? `&justWreath=${justWreath}` : ""
    }${justDisposal ? `&justDisposal=${justDisposal}` : ""}`
  );

  return response.data;
};

export const getMayflowerOrderList = async (
  teamId?: string,
  startDate?: string,
  endDate?: string
) => {
  const response = await b2bOpsAxios.get(
    `/api/team/mayflower_order_list/?${
      startDate ? `startDate=${startDate}` : ""
    }${endDate ? `&endDate=${endDate}` : ""}${
      teamId ? `&teamId=${teamId}` : ""
    }`
  );

  return response.data;
};

export const getTeamHcAllSendHistory = async ({
  startDate,
  endDate,
  teamId,
}: {
  startDate?: string;
  endDate?: string;
  teamId?: string;
}) => {
  const response = await b2bOpsAxios.get(
    `/api/team/hc_order_list/?${startDate ? `startDate=${startDate}` : ""}${
      endDate ? `&endDate=${endDate}` : ""
    }${teamId ? `&teamId=${teamId}` : ""}`
  );

  return response.data;
};

export const getTeamRegionAllSendHistory = async ({
  startDate,
  endDate,
  teamId,
  regionKey,
}: {
  startDate?: string;
  endDate?: string;
  teamId?: string;
  regionKey: string;
}) => {
  const response = await b2bOpsAxios.get(
    `/api/team/region_order_list/?${startDate ? `startDate=${startDate}` : ""}${
      endDate ? `&endDate=${endDate}` : ""
    }${teamId ? `&teamId=${teamId}` : ""}${
      regionKey ? `&regionKey=${regionKey}` : ""
    }`
  );

  return response.data;
};
